import type { FC } from "react";
import React from "react";
import {
  BrandOcean400,
  BrandSunset300,
} from "@arenko-group/nimbus-design-tokens";
import ArenkoLogo from "@/components/ArenkoLogo";
import { getEnv } from "@/helpers/env.helpers";
import { getSessionItem } from "@/helpers/storage.helpers";
import css from "./AppHeader.module.css";
import Breadcrumb from "./Breadcrumb";
import EnvBadge from "./EnvBadge";
import NavMenuToggle from "./NavMenuToggle";
import ProfileMenu from "./ProfileMenu";
import UserInfo from "./UserInfo";

const getIsProd = (environment: string) => {
  return environment === "prod" || !!getSessionItem("use-prod-style", false);
};

type AppHeaderProps = {
  menuToggle: () => void;
  menuExpanded?: boolean;
};

const AppHeader: FC<AppHeaderProps> = ({ menuToggle, menuExpanded }) => {
  const environment = getEnv();
  const isProd = getIsProd(environment);

  return (
    <header id="app-header" className={css.header}>
      <div>
        <div className={css.logoWrapper}>
          <NavMenuToggle onClick={menuToggle} expanded={menuExpanded} />
          <ArenkoLogo identColor={isProd ? BrandOcean400 : BrandSunset300} />
        </div>
        <Breadcrumb testId="header-breadcrumb" />
      </div>
      {!isProd && <EnvBadge>{environment}</EnvBadge>}
      <div>
        <UserInfo />
        <ProfileMenu />
      </div>
    </header>
  );
};

export default AppHeader;
